import { render, staticRenderFns } from "./CustomOverlaysFieldContent.vue?vue&type=template&id=35847ebd&"
import script from "./CustomOverlaysFieldContent.vue?vue&type=script&lang=js&"
export * from "./CustomOverlaysFieldContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports